import React from "react";
import "./locationcards.scss";

const locations = [
	{ name: "Solapur Airport", distance: 3.5, direction: "top", color: "#ff922b", icon: "✈️" },

	{ name: "Passport Office", distance: 5, direction: "right", color: "#e64980", icon: "🏢" },
	{ name: "Siddheshwar Temple", distance: 5.5, direction: "right", color: "#ff6b6b", icon: "🛕" },
	{ name: "Akkalkot Swami Samarth Temple", distance: 35, direction: "right", color: "#51cf66", icon: "🛕" },
	{ name: "Tulja Bhavani Temple", distance: 45, direction: "right", color: "#f59f00", icon: "🛕" },

	{ name: "Naldurg Fort", distance: 40, direction: "left", color: "#20c997", icon: "🏰" },
	{ name: "Pandharpur Temple", distance: 75, direction: "left", color: "#339af0", icon: "🛕" },
	{ name: "Gangapur Guru Datta Temple", distance: 95, direction: "left", color: "#845ef7", icon: "🛕" }
];

const LocationCards = () => {
	const grouped = {
		top: locations.filter(l => l.direction === "top"),
		right: locations.filter(l => l.direction === "right"),
		left: locations.filter(l => l.direction === "left"),
		bottom: locations.filter(l => l.direction === "bottom")
	};

	return (
		<div className="LocationCards-map-container">
			<div className="map-bg"></div>

			<div className="map-content">

				<div className="home">🏠 Home</div>

				{/* TOP */}
				<div className="lane top">
					{grouped.top.map((item, i) => (
						<div key={i} className="map-item">
							<div className="pin" style={{ background: item.color }}>{item.icon}</div>
							<div className="distance">{item.distance} km</div>
							<div className="card">{item.name}</div>
						</div>
					))}
				</div>

				{/* RIGHT */}
				<div className="lane right">
					{grouped.right.map((item, i) => (
						<div key={i} className="map-item">
							<div className="distance">{item.distance} km</div>
							<div className="pin" style={{ background: item.color }}>{item.icon}</div>
							<div className="card">{item.name}</div>
						</div>
					))}
				</div>

				{/* LEFT */}
				<div className="lane left">
					{grouped.left.map((item, i) => (
						<div key={i} className="map-item">
							<div className="distance">{item.distance} km</div>
							<div className="pin" style={{ background: item.color }}>{item.icon}</div>
							<div className="card">{item.name}</div>
						</div>
					))}
				</div>

			</div>
		</div>
	);
};

export default LocationCards;